import { Device } from './../../models/device';
import { Location } from './../../models/location.model';
import { PoiCategory } from './../../models/api/poi-category.model';
import { Poi } from './../../models/api/poi.model';
import { SortData } from './../../models/sort.model';
import { FilterData } from './../../models/filter-input.model';
import { Vehicle } from './../../models/api/vehicle.model';
import { Position } from './../../models/api/vehicle-position.model';
import { ColumnsData } from './../../models/api/column.model';
import { VehicleTrails } from './../../models/api/vehicle-trail.model';
import { Pharmacy } from '../pharmacy.service';

export class AppState {
  positions: Position[] = [];
  vehicleTrails: VehicleTrails[] = [];
  vehicles: Vehicle[] = [];
  pharmacyList: Pharmacy[];
  devices: Device[] = [];
  selectedVehicle: Position;
  selectedPharmacy: Pharmacy;
  filterVehicles: FilterData = {};
  sortData: SortData = {};
  connectionToken: string = '';
  columns: ColumnsData = {
    fleetColumns: {
      column_visibility_item_number: true,
      column_visibility_description: true,
      column_visibility_type: true,
      column_visibility_status: true,
      column_visibility_time: true,
      column_visibility_location: true,
      column_visibility_speed: true,
      column_visibility_fuel: true,
    },
    extColumns: [],
  };
  pois: Poi[] = [];
  bufferPois: Poi[] = [];
  locations: Location[] = [];
  poisCategories: PoiCategory[] = [];
  selectedPoi: number;
  displaySettings: {
    showPoi?: boolean;
  } = {};
}
